export default "__VITE_PUBLIC_ASSET__9fde5265__"